export default __webpack_public_path__ + "static/media/pcard12.805de342.png";